import { render, staticRenderFns } from "./BenefitsSection.vue?vue&type=template&id=e194a994&scoped=true"
import script from "./BenefitsSection.vue?vue&type=script&lang=js"
export * from "./BenefitsSection.vue?vue&type=script&lang=js"
import style0 from "./BenefitsSection.vue?vue&type=style&index=0&id=e194a994&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e194a994",
  null
  
)

export default component.exports